export default class SetLocation {
  constructor(callback) {
    this.callback = callback;
  }

  onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    this.container.style.overflow = 'auto';
    this.container.style.background = 'green';
    this.container.style.padding = '5px 10px';

    this.button = document.createElement('button');
    this.button.textContent = 'Set Location';
    this.button.style.width = '100%';
    this.button.style.padding = '0 5px';
    this.button.style.color = 'white';
    this.button.onclick = this.callback;

    this.container.appendChild(this.button);
    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}
